export const ATTRIBUTES_LIMIT = 15;
